// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"06fca153","453":"84374726"}[chunkId] + ".chunk.js";
};